import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api'

export const rootRouteRef = createRouteRef({
  id: 'tasks-observability'
})

export const catalogRouteRef = createSubRouteRef({
  id: 'tasks-observability:catalog',
  parent: rootRouteRef,
  path: '/catalog'
})

export const searchRouteRef = createSubRouteRef({
  id: 'tasks-observability:search',
  parent: rootRouteRef,
  path: '/search'
})

export const techInsightsRouteRef = createSubRouteRef({
  id: 'tasks-observability:tech-insights',
  parent: rootRouteRef,
  path: '/tech-insights'
})
